import { z } from 'zod';
export const MessageResponseSchema = z.object({ message: z.string() });
//# sourceMappingURL=MessageResponseSchema.js.map